import React, { Component } from 'react';
import * as enums from '../../../utils/enums';
import { Inventory} from 'travco-input-number';
import { TravcoSingleOptionSelector } from 'travco-single-option-selector';
import { TravcoFieldLabel } from 'travco-field-label';

export default class FreesaleComponent extends Component {
    render() {
        let freesaleOptions = [
            {
                id: 0,
                label: 'Open',
                selected: this.props.model.freesale ? this.props.model.freesale.status === enums.OPEN : false
            },
            {
                id: 2,
                label: 'Close',
                selected: this.props.model.freesale ? this.props.model.freesale.status === enums.CLOSED : false
            }
        ];

        let totalLoaded = this.props.model.freesaleRooms ? this.props.model.freesaleRooms.reduce((prev, current) => prev + Number(current.allotment), 0) : 999;
        let maxAllocation = totalLoaded < 0 ? 0 : totalLoaded < enums.OPEN_ALLOCATION_FREESALE_MAX ? totalLoaded : enums.OPEN_ALLOCATION_FREESALE_MAX;

        return (
            <div>
                <div style={{ marginTop: '32px' }}>
                    <TravcoFieldLabel>
                        <input
                            type="checkbox"
                            name="allocationHide"
                            id="ts-f-allocation-hide"
                            checked={this.props.model.freesaleActive}
                            onChange={this.props.onCheckboxChange.bind(this, 'freesaleHideClick')}
                            disabled={this.props.isNotTravcoUser}
                        />{' '}
                        Maximum Freesale
                    </TravcoFieldLabel>
                </div>

                <div className="travco-rooms-display">
                    <div className="trd-item trd-rooms">
                        {this.props.model.freesaleRooms.map((room) => {
                            return (
                                <Inventory
                                    className={'roomType ' + room.name.toLowerCase()}
                                    key={`free-${room.id}`}
                                    label={room.name}
                                    min={0}
                                    max={enums.MAX_ROOM_ALLOCATION}
                                    controls
                                    value={room.allotment < 0 ? 0 : room.allotment}
                                    onChange={this.props.onRoomTypeMaxAllotmentChange.bind(this, true, room)}
                                    disabled={!this.props.model.freesaleActive}
                                />
                            );
                        })}
                    </div>
                    <div className="trd-item trd-totals">
                        <Inventory
                            className="freesale"
                            label="Total Freesale"
                            min={enums.OPEN_ALLOCATION_FREESALE_MIN}
                            max={maxAllocation}
                            controls
                            value={this.props.model.freesale ? this.props.model.freesale.count : 0}
                            onChange={this.props.onConfigurationOptionChange.bind(this, 'count')}
                            disabled={
                                !this.props.model.freesaleActive ||
                                !(this.props.model.freesale ? this.props.model.freesale.status == enums.FIXED : true)
                            }
                        />

                        <Inventory
                            className="freesale-release-days"
                            label="Release Days"
                            min={enums.OPEN_ALLOCATION_FREESALE_MIN}
                            max={
            
                                    99
                            }
                            controls
                            value={this.props.model.freesale ? this.props.model.freesale.releaseDays : 0}
                            onChange={this.props.onConfigurationOptionChange.bind(this, 'releaseDays')}
                            disabled={
                                !this.props.model.freesaleActive ||
                                !(this.props.model.freesale
                                    ? this.props.model.freesale.status == enums.FIXED ||
                                      this.props.model.freesale.status == enums.OPEN
                                    : true)
                            }
                        />
                    </div>

                    <div className="trd-item trd-controls">
                        <TravcoSingleOptionSelector
                            className="rate-calculation"
                            values={freesaleOptions}
                            onClick={this.props.onFreesaleStatusChange.bind(this)}
                            id="free-nights-rate-calculation"
                            disabled={!this.props.model.freesaleActive}
                            btnClassNameInactive="btn-default"
                            btnClassNameActive="btn-success"
                            btnIsGroup={false}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
